export default __webpack_public_path__ + "images/stripe-payment-element/mastercard-3ae6e3b0da7f2225e507f35471d60a16.svg";